<template>
  <header class="header">
    <div class="brand">
      <img src="@/assets/magpie.jpeg" alt="Magpie logo" class="logo" />
      <h1 class="title">{{ title }}</h1>
    </div>
    <div class="tagline" :title="description">&quot;{{ description }}&quot;</div>
  </header>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
})
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  height: var(--header-height);
  padding: 0 var(--space-4);
  background: var(--color-bg-raised);
  border-bottom: 1px solid var(--color-border);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-width: 0;
}

.logo {
  height: var(--logo-size);
  width: var(--logo-size);
  object-fit: cover;
  border-radius: var(--radius-sm);
  flex: none;
}

.title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--fs-title);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--color-text);
  white-space: nowrap;
}

.tagline {
  font-size: var(--fs-sm);
  color: var(--color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

@media (max-width: 640px) {
  .tagline {
    display: none;
  }
}
</style>
